import {getIndexCount} from '../api';
import {listShipper, listShipperItem} from "../../../../api";

const myTasks = {
  namespaced: true,
  state: {
    indexCountObj: null,
    shipperObj: null
  },
  mutations: {
    GET_INDEX_COUNT(state, resp) {
      state.indexCountObj = resp.obj;
    },
    LIST_SHIPPER(state, data) {
      state.shipperObj = data.obj;
    },
  },
  actions: {
    async getIndexCount({commit}, obj) {
      let resp = await getIndexCount(obj);
      commit('GET_INDEX_COUNT', resp);
    },
    async listShipper({commit}, obj){
      let resp = await listShipper(obj);
      commit('LIST_SHIPPER', resp);
    },
  }
}

export default myTasks



// WEBPACK FOOTER //
// ./src/page/myTasks/myTasks/store/myTasks.store.js